import * as angular from 'angular';
import * as _ from 'lodash';

import { IRootScope } from '../../../IRootScope';
import * as events from '../../../common/events';
import { IAuthorizationService, IConfigurationService, IAuthenticationService, IStoreService } from '../../../services';
import { ApplicationUserViewModel, ComponentDefinition, Dictionary, OnlineUserDto } from '../../../models';
import { Roles } from '../../../common/';
import { Store, StoreElement } from '../../../stateManagement';

class TopNavController implements angular.IComponentController {
    backButtonDisabled: boolean;
    backButtonVisibility: boolean;
    canEdit: boolean;
    currentState: string;
    editButtonDisabled: boolean;
    editButtonVisibility: boolean;
    isApplicationLocked: boolean;
    isEditMode: boolean;
    logoFileName: string;
    onlineUsers: Dictionary<OnlineUserDto>;
    users: Dictionary<ApplicationUserViewModel>;

    private _unsubscribe: () => void;

    static $inject = [
        '$scope',
        '$rootScope',
        '$state',
        'authenticationService',
        'authorizationService',
        'configurationService',
        'storeService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: IRootScope,
        private _$state: angular.ui.IStateService,
        private _authenticationService: IAuthenticationService,
        private _authorizationService: IAuthorizationService,
        private _configurationService: IConfigurationService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.isEditMode = this._$rootScope.isEditMode;

        this.canEdit = true;
        this._configurationService
            .getLogoFileName()
            .then(data => this.logoFileName = data);

        this._$scope.$watch(
            () => this._$state.current,
            () => {
                const data = this._$state.current.data;

                this.backButtonDisabled = data?.backButtonDisabled
                    && data?.backButtonDisabled();
                this.backButtonVisibility = data?.backButtonVisibility
                    && data?.backButtonVisibility();
                this.editButtonVisibility = data?.editButtonVisibility
                    && data?.editButtonVisibility()
                    && this._authorizationService.canEdit();
                this.editButtonDisabled = data?.editButtonDisabled
                    && data?.editButtonDisabled()
                    && this._authorizationService.canEdit();

                if (!this.editButtonVisibility && this._$rootScope.isEditMode) {
                    this._$rootScope.$broadcast(events.toggleEditMode, false);
                }
                this.currentState = this._$state.current.name;
            }
        );

        this._$scope.$on(events.formDirtyChanged, (event, data) => {
            this.canEdit = !data;
        });

        this._$scope.$on(events.toggleEditMode, () => {
            this.isEditMode = this._$rootScope.isEditMode;
        });

        this._unsubscribe = this._storeService.register(
            store => this.refreshStore(store),
            [ StoreElement.Application, StoreElement.Authentication ]
        );
    }

    $onDestroy(): void {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    isAuthenticated(): boolean {
        return this._authorizationService.isAuthenticated();
    }

    authenticatedName(): string {
        return this._authenticationService.authentication.userName;
    }

    isConnected(): boolean {
        return this._authorizationService.isConnected();
    }

    canCreateTickets(): boolean {
        return this.isConnected()
            && this._authenticationService.authentication
            && this._authenticationService.authentication.roles
            && this._authenticationService.authentication.roles.filter(d => d !== Roles.reader && d !== Roles.superAdministrator).length > 0;
    }

    toggleEditMode(): void {
        this._$rootScope.$broadcast(events.toggleEditMode);
    }

    back(): void {
        this._$rootScope.$broadcast(events.backButtonClick);
    }

    private refreshStore(store: Store) {
        this.isApplicationLocked = store.application?.value?.isLocked;
    }
}

export const wtTopNav: ComponentDefinition = {
    componentId: 'wtTopNav',
    controller: TopNavController,
    template: require('./topNav.component.html'),
    controllerAs: 'vm',
    bindings: {
        isMobileMode: '=?',
        setMobileMode: '&?'
    }
};